/**
 * React Query (TanStack Query) client configuration.
 *
 * Single source of truth for cache defaults across the app. Currently used
 * primarily by the Sales Dashboard feature; other features can opt in by
 * just calling useQuery with this client.
 *
 * Defaults:
 *   - staleTime 15s: mirrors the previous dashboard polling interval. Data
 *     within 15s is served from cache without refetch.
 *   - gcTime 5min: unused queries held in memory briefly to survive mount/
 *     unmount cycles (e.g., closing and reopening a copilot).
 *   - retry once on failure.
 *   - refetchOnWindowFocus disabled: dashboard has its own polling, no need
 *     for extra refetches when users tab back.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
